/* eslint semi:0 */
/**
 * HOC to connect Redux and dynamically reconfigure store, reducers,
 * sagas for mounting component configs and pass mountpoint data as props
 * to mounted component.
 */
import { Provider } from 'react-redux'
import { componentMount } from '../store/mountedComponents/mountedComponents.actions'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import appStore, { dispatch, addReducer } from './appStore'

export class MountedComponent extends Component {
  componentDidMount() {
    const { container, options } = this.props

    const {
      component: MountingComponent,
      name: componentName,
      stateKey,
      reducer,
      props,
      sagas,
    } = container
    const componentProps = { options, ...(props || {}) }
    const ComponentInstance = <MountingComponent {...componentProps} />

    if (stateKey !== undefined && reducer !== undefined) {
      addReducer(stateKey, reducer)
    }
    dispatch(componentMount(ComponentInstance, componentName, sagas))
    const componentWithStoreProps = {
      store: appStore,
      children: ComponentInstance,
    }
    this.renderedView = <Provider {...componentWithStoreProps} />
    this.forceUpdate()
  }

  render() {
    return this.renderedView || false
  }
}

MountedComponent.propTypes = {
  dispatch: PropTypes.func,

  container: PropTypes.object,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/mountedComponent.js